(() => {
  if (window.__mmGreetingCard) return;
  window.__mmGreetingCard = true;

  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const sync = (card) => {
    const msg = card.querySelector('.mm-card__msg');
    const btn = card.querySelector('[data-mm-card-add]');
    const count = card.querySelector('[data-mm-card-count]');
    const hint = card.querySelector('[data-mm-card-hint]');
    if (!msg || !btn) return;
    const has = msg.value.trim().length > 0;
    btn.disabled = !has;
    if (count) count.textContent = msg.value.length;
    if (hint) hint.textContent = has ? 'הברכה תודפס על הכרטיס' : 'כתבו ברכה כדי להוסיף';
  };

  const refreshCart = () => document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

  const post = (url, body) =>
    fetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then((r) => {
      if (!r.ok) throw new Error('cart request failed');
      return r.json();
    });

  document.addEventListener('input', (e) => {
    const card = e.target.closest && e.target.closest('[data-mm-card]');
    if (card && e.target.classList.contains('mm-card__msg')) sync(card);
  });

  document.addEventListener('toggle', (e) => {
    const card = e.target.closest && e.target.closest('[data-mm-card]');
    if (card) sync(card);
  }, true);

  document.addEventListener('click', async (e) => {
    const addBtn = e.target.closest && e.target.closest('[data-mm-card-add]');
    const removeBtn = e.target.closest && e.target.closest('[data-mm-card-remove]');
    if (!addBtn && !removeBtn) return;

    const card = (addBtn || removeBtn).closest('[data-mm-card]');
    const lineKey = card.dataset.lineKey;
    const btn = addBtn || removeBtn;
    btn.disabled = true;

    try {
      if (removeBtn) {
        await post('cart/change.js', { id: lineKey, quantity: 0 });
      } else {
        const message = card.querySelector('.mm-card__msg').value.trim();
        const picked = card.querySelector('input[name="mm-card-variant"]:checked');
        if (!message || !picked) { btn.disabled = false; return; }
        const properties = { [card.dataset.messageKey]: message };

        // Editing an existing card: replace it so the design and the message both update.
        if (lineKey) await post('cart/change.js', { id: lineKey, quantity: 0 });
        await post('cart/add.js', { items: [{ id: Number(picked.value), quantity: 1, properties }] });
      }
      refreshCart();
    } catch (err) {
      btn.disabled = false;
      alert('משהו השתבש, נסו שוב');
    }
  });

  const initAll = () => document.querySelectorAll('[data-mm-card]').forEach(sync);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('cart:change', () => setTimeout(initAll, 300));
  document.addEventListener('cart:refresh', () => setTimeout(initAll, 600));
})();
